import { render } from "./visitorAgreeApply.vue?vue&type=template&id=9d8c61a0&scoped=true"
import script from "./visitorAgreeApply.vue?vue&type=script&lang=js"
export * from "./visitorAgreeApply.vue?vue&type=script&lang=js"

import "./visitorAgreeApply.vue?vue&type=style&index=0&id=9d8c61a0&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d8c61a0"]])

export default __exports__